<template>
    <van-list
        :v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onload"
        >
        <div v-for="(item,index) of list" :key="index">
            <van-cell :label="item.order_num==undefined || item.order_num==0 ? '' : '订单数:'+item.order_num" is-link @click="handleClient(item)">
                <template #title>
                    <span class="custom-title">{{item.user_nickname}}</span>
                    <span class="lightGray" v-if="!item.name ? false : true">({{item.name}})</span>
                </template>
                <template #icon>
                    <img class="userAvatar"  :src="item.avatar" alt="">
                </template>
            </van-cell>
            <van-divider style="background:rgba(241,241,241,1);margin:0 15px" />
        </div>
    </van-list>
</template>

<script>
import cellList from "@/components/cellList"
export default {
    props:["is_order"],
    data() {
        return {
            list:[],
            finished:false,
            loading:false,
            page:1,
            timer:null
        };
    },
    created(){
    },
    methods:{
        onload(){
            if(!this.timer){
                this.timer = setTimeout(() => {
                    this.getList()       //请求列表数据的方法
                    this.timer = null;
                }, 200)
            }
        },
        getList(){
                this.$https.fetchPost("user/myUsers",{"page":this.page,"is_order":this.is_order},{headers:{"XX-Token":this.$store.state.token}})
                .then(result=>{
                    let data=result.data;
                    // console.log(data)
                    if(data.code==1 && data.data.length!=0){
                        this.list=[...this.list,...result.data.data];
                        this.loading= false;
                        this.page++;
                    }else{
                        this.finished= true;
                    }
                })
        },
        // 点击查看客户信息
        handleClient(item){
            this.$store.commit('SET_CLIENTINFO',item)
            this.$router.push({path:"/clientInfo"})
        },
    },
    computed:{
    },
    components:{
        cellList,
    },
}
</script>

<style scoped>
  .van-cell{
      padding:10px 22px;
      align-items:center;
      background: transparent;

  }
    .custom-title{
        font-size: 15px;
    }
    .van-cell__label,.lightGray{
        color:#ccc;
        font-size: 12px;
    }
     .userAvatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 18px;
    }
</style>


// WEBPACK FOOTER //
// src/components/userList.vue